<template>
  <v-container fluid>
    <v-layout>
      <v-btn flat color="primary" title="Refresh" @click="getAllCodes">
          <v-icon dark class="mx-2">refresh</v-icon>
            {{ $t('refresh') }}
      </v-btn>
      <v-btn flat color="primary" title="Add registration code" @click="addCode('tenant')" v-if="showAddRegistrationCodeBtn">
          <v-icon dark class="mx-2">add</v-icon>
            {{ $t('tenantRegistrationCode') }}
      </v-btn>
      <v-btn flat color="primary" title="Add registration code" @click="addCode('warehouse')" v-if="showAddRegistrationCodeBtn">
          <v-icon dark class="mx-2">add</v-icon>
            {{ $t('warehouseRegistrationCode') }}
      </v-btn>
      <v-flex md7 v-if="switchEnvForShowBtns">
        <v-layout align-center justify-space-between>
          <v-flex md5>
            <v-text-field
              :label="$t('key')"
              name="key"
              id="key"
              v-model="key"></v-text-field>
          </v-flex>
          <v-flex md5 class="ml-2">
            <v-text-field
              :label="$t('email')"
              name="email"
              id="email"
              v-model="email"></v-text-field>
          </v-flex>
          <v-btn flat color="primary" title="Register" @click="registerUser" class="ml-2">
              {{ $t('registerUser') }}
          </v-btn>
          <v-btn flat color="primary" title="Verify signup" @click="verifySignupEmailAuth" class="ml-2">
              Verify signup
          </v-btn>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout justify-start>
      <v-flex :style="{ whiteSpace: 'pre-wrap' }">{{ $t('status') }}:       {{status}}</v-flex>
    </v-layout>
    <v-layout justify-start v-if="verifySignupResult">
      <v-flex :style="{ whiteSpace: 'pre-wrap' }">
        verifySignupResult: {{ JSON.stringify(verifySignupResult) }}
      </v-flex>
    </v-layout>
    <v-layout>
      <v-progress-linear :indeterminate="loading"></v-progress-linear>
    </v-layout>
    <br>
    <v-flex sm8 md5>
      <v-layout justify-space-between>
        <v-flex sm4 class="font-weight-bold text-sm-left">{{ $t('registrationCode') }}</v-flex>
        <v-flex sm4 class="font-weight-bold text-sm-left">{{ $t('registrationType') }}</v-flex>
        <v-flex sm4 class="font-weight-bold text-sm-left">{{ $t('createTime') }}</v-flex>
      </v-layout>
    </v-flex>
    <v-layout v-for="item in codes" column :key="item.code">
      <v-layout justify-start>
        <v-flex sm8 md5>
          <v-layout>
            <v-flex sm4 class="text-sm-left">{{item.code}}</v-flex>
            <v-flex sm4 class="text-sm-left">{{item.type || ''}}</v-flex>
            <v-flex sm4 class="text-sm-left">{{toTimestampString(item.createTime)}}</v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-spacer></v-spacer>
    </v-layout>
  </v-container>
</template>

<script>
import { toTimestampString, convertTimestampToDateInObj } from '@/utils/tools'

export default {
  name: 'Administrator',
  data () {
    return {
      loading: false,
      error: '',
      codes: [],
      key: '',
      email: '',
      verifySignupResult: null
    }
  },
  computed: {
    users () {
      return this.$store.getters.users
    },
    status () {
      return this.loading ? `${this.$t('processing')}...` : (this.error || this.$t('finished'))
    },
    processEnv () {
      return process.env.NODE_ENV
      // return 'amos'
    },
    registrationAdvanceUsers () {
      return this.$store.getters.registrationAdvanceUsers || []
    },
    showAddRegistrationCodeBtn () {
      return this.switchEnvForShowBtns || this.registrationAdvanceUsers.includes(this.$store.getters.user.email)
    },
    switchEnvForShowBtns () {
      switch (this.processEnv) {
        case 'far800':
        case 'fsd915':
        case 'eagle':
          const { isSuperUser = false } = this.$store.getters.user || {}
          return isSuperUser
        default:
          return this.hasAuthToFunctionality('registrationAdvance')
      }
    }
  },
  mounted () {
    this.$store.dispatch('loadSystemInfo')
  },
  methods: {
    toTimestampString: toTimestampString,
    async registerUser () {
      if (this.$store.getters.user.isAdmin && this.key && this.email) {
        let payload = {user: this.$store.getters.user, uid: this.key, email: this.email}
        delete payload.user.isAdmin
        await this.$store.dispatch('reset_state')
        await this.$store.dispatch('loadUser', payload)
      }
    },
    verifySignupEmailAuth () {
      if (!this.email) {
        this.error = 'Email is required'
        return Promise.resolve()
      }

      return this.runProcess(
        this.$store.dispatch('verifySignupEmailAuth', this.email)
          .then(result => {
            this.verifySignupResult = result
          })
      )
    },
    runProcess (promise) {
      this.loading = true
      this.error = ''
      this.verifySignupResult = null
      return Promise.resolve(promise)
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.error = error.message
          this.loading = false
          console.error(error)
        })
    },
    getAllCodes () {
      this.loading = true
      return this.runProcess(this.$store.dispatch('getAllRegistrationCode')
        .then(docs => {
          this.codes = docs.docs.map(doc => {
            let code = convertTimestampToDateInObj(doc.data())
            return code
          })
        }))
    },
    addCode (type = 'tenant') {
      return this.runProcess(this.$store.dispatch('addRegistrationCode', {type})
        .then(code => this.codes.push(code)))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Administrator.vue